export default __webpack_public_path__ + "static/press_3-90defd2b860891cb1f54f4bff00c64b9.jpg";